"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MONEY_ORDER = exports.CHECK = exports.DEBIT_CARD = exports.CREDIT_CARD = exports.NO_PAYMENT = void 0;
exports.NO_PAYMENT = "no_payment";
exports.CREDIT_CARD = "credit_card";
exports.DEBIT_CARD = "debit_card";
exports.CHECK = "check";
exports.MONEY_ORDER = "money_order";